import './styles.scss';

/* global shareon */
export default function initShareButtons() {
  const shareContainers = document.querySelectorAll('.shareon');
  shareon();
  [...shareContainers].forEach((container) => {
    container.classList.remove('d-none');
  });
}
